import React from 'react';
import Table from 'src/ui/library/Table';

class HorizontalTable extends React.Component {
  state = {
    showDelete: false,
    rowsSelected: [],
  };

  tableFooter = () => {
    const { addNewRowFn, deleteRowsFn, cancelRowsFn } = this.props;
    const { rowsSelected, showDelete } = this.state;

    return (
      <section className="table-footer">
        {showDelete ? (
          <React.Fragment>
            <a onClick={deleteRowsFn.bind(null, rowsSelected)} key={'delete'}>
              Delete
            </a>
            <a onClick={cancelRowsFn()} key={'cancel'}>
              Cancel
            </a>
          </React.Fragment>
        ) : (
          <a onClick={addNewRowFn}>+ Add Row</a>
        )}
      </section>
    );
  };

  onTableChange = (actionType, data) => {
    if (actionType === 'rowSelected') {
      const { selectedRows } = data.model;

      this.setState({
        showDelete: selectedRows.length ? true : false,
        rowsSelected: selectedRows,
      });
    }
  };

  render() {
    const {
      label,
      setUpdateModelFn,
      addNewRowFn,
      deleteRowsFn,
      elementActions,
      cancelRowsFn,
      setTableModelFn,
      setCancelSelectedRows,
      setUpdateColumnFn,
      ...otherProps
    } = this.props;

    return (
      <div className={'horizontal-table'}>
        <span className={'table-label'}>{label}</span>
        <Table
          footer={this.tableFooter}
          updateModel={setUpdateModelFn}
          setTableModel={setTableModelFn}
          updateColumn={setUpdateColumnFn}
          onTableChange={this.onTableChange}
          cancelSelectedRows={setCancelSelectedRows}
          {...otherProps}
        />
      </div>
    );
  }
}

export default HorizontalTable;
